import classNames from "classnames";
import React from "react";
import api from "../../../../api";
import { CustomerAvatar } from "../../../../components/render-file/CustomerAvatar";
import { Customer } from "../../../../core/api/models/customer";
import EditCompanyUser from "./EditCompanyUser";

interface ISearchCompanyProps {
  onSelect?: (userId?: string) => void;
  wraperClassName: string;
  setStage: (stage: string) => void;
  companyId?: string;
  customerDetails: Customer;
  selectedContactIds: string[];
  setHasContact?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchAndAssignCompanyUser: React.FunctionComponent<ISearchCompanyProps> = (
  props
) => {
  const { selectedContactIds } = props;

  const [refresh, setRefresh] = React.useState(false);
  const [selectedCompnayId, setSelectedCompanyId] = React.useState<
    Customer[] | null
  >(null);

  const [selectedCustomer, setSelectedCustomer] = React.useState<Customer>(
    props.customerDetails
  );

  const [addUserOpen, setAddUserOpen] = React.useState(false);

  const ref = React.useRef<HTMLDivElement>(null);

  const getUsers = async () => {
    const userData = await api.customer.listCompanyContactUsers({
      parentCompanyCustomerId: props.companyId!,
      page: 1,
      perPage: 50,
      companyId: props.companyId!,
    });
    if (userData?.length && props.setHasContact) {
      props.setHasContact(true);
    }
    setSelectedCompanyId(userData);
    if (
      props.onSelect &&
      !selectedContactIds.length &&
      userData?.length &&
      userData[0]._id
    ) {
      props.onSelect(userData[0]._id);
    }
  };

  React.useEffect(() => {
    getUsers();
  }, [refresh]);

  const onAddNewUser = async () => {
    props.setStage("add-user");
  };

  return !addUserOpen ? (
    <div key={"search-customer"} ref={ref}>
      <div className="p-4">
        {selectedCompnayId && (
          <div className="form-group font-weight-semibold mb-4">
            <label htmlFor="" className="font-sm">
              Contact
            </label>
            {selectedCompnayId?.length === 0 ? (
              <p className="mb-0 font-xs text-gray-600 font-weight-semibold">
                No users added. Please add user.
              </p>
            ) : (
              <div className="row no-gutters">
                <div className="col col-12">
                  <div className="border">
                    <ul className="list-unstyled mb-0">
                      {selectedCompnayId?.map((user, index) => {
                        return (
                          <li
                            key={index}
                            className={classNames({
                              "border-bottom px-3 py-2 d-flex align-items-center cursor-pointer align-items-sm-start": true,
                              "bg-white": !selectedContactIds?.find(
                                (id) => id === user._id
                              ),
                              "bg-gray-100": selectedContactIds?.find(
                                (id) => id === user._id
                              ),
                            })}
                          >
                            <div className="mr-2 mt-2">
                              <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                                <svg>
                                  <circle
                                    r="12"
                                    cx="50%"
                                    cy="50%"
                                    className="default"
                                  ></circle>
                                  <circle
                                    r="12"
                                    cx="50%"
                                    cy="50%"
                                    className="progress"
                                    stroke-dasharray="117"
                                    stroke-dashoffset="75"
                                  ></circle>
                                </svg>
                                <CustomerAvatar
                                  id={user?._id}
                                  className="img-cover img-fluid rounded-circle position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                                  alt=""
                                  title={user?.name}
                                  imageUrl={user?.photo?.location}
                                  image={user?.photo}
                                ></CustomerAvatar>
                              </div>
                            </div>
                            <div className="py-1">
                              <h6 className="mb-1">{user.fullName}</h6>
                              <p className="mb-0 font-xs text-gray-600 font-weight-semibold">
                                {user.designation?.name}{" "}
                                {user.designation?.name && (
                                  <div className="dot bg-gray-400 mx-2 top-0"></div>
                                )}
                                {user.phones?.find((x) => x.isPrimary)?.phone}
                              </p>
                            </div>

                            <i
                              onClick={() => {
                                setSelectedCustomer(user);
                                setAddUserOpen(true);
                              }}
                              className="icon-edit icon-box pt-1 border border cursor-pointer d-flex icon-box justify-content-center ml-auto rounded-sm"
                            ></i>
                            <i
                              onClick={() => {
                                props.onSelect?.(user._id);
                              }}
                              className={classNames({
                                "icon-add icon-box border align-items-center border cursor-pointer d-flex icon-box justify-content-center ml-4 rounded-sm": true,
                                "icon-add": !selectedContactIds?.find(
                                  (id) => id === user._id
                                ),
                                "icon-close bg-blue text-white font-sm rounded": selectedContactIds?.find(
                                  (id) => id === user._id
                                ),
                              })}
                            ></i>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="col-auto mt-1 mt-md-0 pl-0">
          <div className="d-inline-flex align-items-right flex-wrap mr-lg-5 mr-sm-3">
            <div className="bg-white mr-3   ">
              {selectedCompnayId !== null && (
                <button
                  onClick={onAddNewUser}
                  className="btn btn-outline-primary font-normal font-weight-bold"
                >
                  <i className="icon-plus mr-1"></i>Add New Contact
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <>
      <div className="d-flex border-bottom align-items-center py-3 px-4">
        <h6 className="mb-0">Add Contact</h6>
      </div>
      <EditCompanyUser
        onCreateCustomer={(details: Customer) => {
          setRefresh(!refresh);
          setAddUserOpen(false);
        }}
        customerDetails={selectedCustomer}
        isContact
        parentCompanyCustomer={props.customerDetails}
        onCLose={() => {
          setAddUserOpen(false);
        }}
      ></EditCompanyUser>
    </>
  );
};

export default SearchAndAssignCompanyUser;
